import {AxiosServer} from '../../utils';
import {message} from 'antd';

const namespace = 'api_';




const SET = (value) =>(dispatch,getState)=>{
	dispatch({type: namespace+'forcedUpdate', payload: value})
}

const GET =(value)=>(dispatch,getState)=>{	
	let Axios = AxiosServer();		
	return Axios.post(value.url,value.body?value.body:null).then((res)=>{		
		console.log('res',res)
		if (res.data){					
			dispatch({type: namespace+'forcedUpdate', payload: {FetchData:res.data}})  // 翻页的时候，先更新 dataLoading: true
			return '请求成功'
		}else{			
			return '请求失败'
		}	
		
		
	}).catch((err)=>{
		dispatch({type: namespace+'forcedUpdate', payload: {FetchData:err.message}})  // 翻页的时候，先更新 dataLoading: true
		return err.message;
	});	
	
}


export {GET,SET };